import { createFileRoute } from '@tanstack/react-router'
import EditionBookClubList from 'Edition/components/sections/General/EditionBookClubList'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-bookclubs')({
    component: EditionBookClubList,
})
